import React from "react";
import Hero from "../sections/Hero";
import MoodSection from "../sections/MoodSection";
import PicksSection from "../sections/PicksSection";
import GuidesSection from "../sections/GuidesSection";
import EventsSection from "../sections/EventsSection";
import OffersSection from "../sections/OffersSection";
import TatoClubSection from "../sections/TatoClubSection";
import AboutSection from "../sections/AboutSection";
import BusinessTeaserSection from "../sections/BusinessTeaserSection";
import LandingFooter from "../components/LandingFooter";

// cities/selectedCity are owned by LandingPage now (shared with LandingNav's
// location dropdown) — HomeView just passes them through.
const HomeView = ({ onGoBusiness, onGoSignin, cities, selectedCity }) => {
  return (
    <>
      <main id="top" style={{ flex: 1 }}>
        <Hero cities={cities} />
        <MoodSection selectedCity={selectedCity} />
        <PicksSection selectedCity={selectedCity} />
        <GuidesSection selectedCity={selectedCity} />
        <EventsSection selectedCity={selectedCity} />
        <OffersSection onGoSignin={onGoSignin} />
        {false && <TatoClubSection />}
        <AboutSection />
        <BusinessTeaserSection onGoBusiness={onGoBusiness} />
      </main>
      <LandingFooter cities={cities} onGoBusiness={onGoBusiness} />
    </>
  );
};

export default HomeView;
